<section class="page-shell">
  <header class="page-header">
    <h4>Bouquet de service ({{ page()?.totalCount ?? 0 }})</h4>

    <div class="page-header-actions">
      <oui-button
        iconSuffix="sync"
        (click)="reload()"
        [disabled]="loading()">
        Recharger
      </oui-button>
    </div>
  </header>

  @if (error() && !loading()) {
    <dbw-state-card
      appearance="error"
      title="Chargement impossible">
      <p>{{ error() }}</p>
    </dbw-state-card>
  }

  <section class="content-grid">
    <article class="panel search-panel dbw-card dbw-card--xl">
      <h5>Filtres</h5>

      <div class="filters">
        <div class="filters-group">
          <div class="subtitle-1">Consultant</div>
          <div class="filters-row">
            <oui-textfield
              label="ConsultantId"
              type="number"
              [value]="consultantIdFilter()"
              (valueChange)="onConsultantIdFilterChange($event ? $event.toString() : '')">
            </oui-textfield>
            <oui-textfield
              label="Code consultant"
              [value]="consultantCodeFilter()"
              (valueChange)="onConsultantCodeFilterChange($event ? $event.toString() : '')">
            </oui-textfield>
            <oui-textfield
              class="search-field-name"
              label="Nom / prénom consultant"
              [value]="consultantNameFilter()"
              (valueChange)="onConsultantNameFilterChange($event ? $event.toString() : '')">
            </oui-textfield>
            <oui-select-filter
              class="search-field-status"
              label="Statut abonnement"
              type="list"
              listPlaceholder="Rechercher un statut"
              [listOptions]="subscriptionStatusOptions"
              [value]="subscriptionStatusFilter()"
              (valueChange)="onSubscriptionStatusFilterChange($event ?? [])">
            </oui-select-filter>
          </div>
        </div>
      </div>
    </article>

    <article class="panel dbw-card dbw-card--xl">
      <div class="panel-heading">
        <div>
          <h5>Résultats</h5>
          <p>{{ page()?.totalCount ?? 0 }} consultant(s) correspondant au filtre.</p>
        </div>
      </div>

      @if (loading()) {
        <dbw-state-card
          appearance="loading"
          [compact]="true">
          <p>Chargement du reporting Bouquet de service en cours.</p>
        </dbw-state-card>
      }

      @if (!loading() && !error() && (page()?.items?.length ?? 0) === 0) {
        <div class="empty-state">Aucun consultant ne correspond au filtre courant.</div>
      }

      @if (!loading() && (page()?.items?.length ?? 0) > 0) {
        <div class="table-shell">
          <oui-table
            class="data-table"
            [lineSizing]="'dense'">
            <table
              mat-table
              [dataSource]="page()?.items ?? []">
              <ng-container matColumnDef="consultant">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Consultant
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <dbw-consultant-card
                    [id]="row.consultantId"
                    [code]="row.consultantCode || '-'"
                    [name]="row.displayName || 'Consultant #' + row.consultantId"
                    [statusCode]="row.statusCode"></dbw-consultant-card>
                </td>
              </ng-container>

              <ng-container matColumnDef="subscription">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Statut abonnement
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <dbw-consultant-subscription-tag
                    [isSubscribed]="row.isSubscribed"
                    [subscriptionStatus]="row.subscriptionStatus"></dbw-consultant-subscription-tag>
                </td>
              </ng-container>

              <ng-container matColumnDef="subscriptionEndDate">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Date de fin
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  {{ row.subscriptionEndDate ? (row.subscriptionEndDate | date: 'dd/MM/yyyy') : '-' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="header-right">
                  Actions
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <div class="row-actions">
                    @if (row.subscriptionStatus === 'subscribed' || row.subscriptionStatus === 'terminationScheduled') {
                      <oui-button
                        type="icon"
                        ouiTooltip="Résilier l'abonnement"
                        color="error"
                        (click)="terminateSubscription(row)"
                        [disabled]="!canManageSubscription() || actionInProgressConsultantId() !== undefined">
                        <oui-icon>block</oui-icon>
                      </oui-button>
                    }

                    @if (row.subscriptionStatus === 'notSubscribed' || row.subscriptionStatus === 'terminationScheduled') {
                      <oui-button
                        type="icon"
                        [ouiTooltip]="getActivationTooltip(row)"
                        color="valid"
                        (click)="activateSubscription(row)"
                        [disabled]="!canManageSubscription() || actionInProgressConsultantId() !== undefined">
                        <oui-icon>check_circle</oui-icon>
                      </oui-button>
                    }
                  </div>
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </oui-table>

          <mat-paginator
            [length]="page()?.totalCount ?? 0"
            [pageIndex]="page()?.pageIndex ?? pageIndex()"
            [pageSize]="page()?.pageSize ?? pageSize()"
            [pageSizeOptions]="pageSizeOptions"
            [showFirstLastButtons]="true"
            (page)="onPageChange($event)">
          </mat-paginator>
        </div>
      }
    </article>
  </section>
</section>
